var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "608.98 400 45.82 34.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill markers",
      fill: "rgb(87, 148, 248)"
    },
    d: "M 630.296 400 L 616.498 421.988 L 623.349 433.992 L 635.624 433.992 L 629.194 424.209 L 643.409 400 L 630.296 400 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(153, 155, 178)",
      stroke: "rgb(153, 155, 178)",
      strokeMiterlimit: 14,
      strokeOpacity: 0
    },
    d: "M 636.402 411.941 L 642.042 422.837 L 635.626 433.992 L 648.229 433.992 L 654.301 422.72 C 654.301 422.72 648.229 412.042 648.229 411.923 C 648.229 411.803 636.514 411.823 636.402 411.941 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(91, 145, 249)",
      fill: "rgb(91, 145, 249)"
    },
    d: "M 613.623 426.662 L 609.484 433.51 L 617.945 433.513 L 613.623 426.662 Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtIconLogo);
export default __webpack_public_path__ + "static/media/BT Icon Logo.190eafe63f4c90a153993990c6b478cd.svg";
export { ForwardRef as ReactComponent };